import JobStatuses, { TJobStatuses } from 'Models/jobs/JobStatuses';

export default function isJobStatus(status: string): status is TJobStatuses {
	return !!JobStatuses[status];
}
